// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vNRZ","content":"styles_content__3d6Wg"};